import ChkIcon from './common/chk.svg';
import ChkOnIcon from './common/chk_on.svg';

const commonStyle = `
  /*============어드민페이지===========*/
    /*====양쪽 사이드바====*/
    
    .admin_console {
      position: absolute;
      top: 250px;
      box-sizing: border-box;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      transition: all 0.3s;
      z-index: 999;
    }
    .left_console {
      width: 260px;
      left: 0;
      border-radius: 0 8px 8px 0;
      height: 620px;
      overflow: hidden;
      background: rgba(59, 59, 63, 0.9);
    }
    .right_console {
      width: 260px;
      right: 0;
      border-radius: 8px 0 0 8px;
      height: 620px;
      overflow: hidden;
    }
    
    /*=====lest_console========*/
    .left_console.on .text_container_top,
    .left_console.on .text_container_content { display: none; }
    .left_console .left_console_folding { display: none;}
    .left_console.on .left_console_folding { display: block;}
    .left_console.on { width: 30px; height: 220px; padding: 0; }
    .left_console.on .left_console_folding button {
      position: relative;
      display: block;
      width: 30px;
      height: 220px;
      transition: all 0.3s;
    }
    .left_console.on .left_console_folding button .arrow_div{
      position: absolute;
      top: 0;
      left: 0;
      width: 30px;
      height: 30px;
      text-align: center;
    }
    .left_console.on .left_console_folding button .number_div{
      height: calc(100% - 30px);
      width: 30px;
      margin-top: 30px;
    }
    .left_console.on .left_console_folding button img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(180deg);
      width: 10px;
      height: 10px;
      opacity: 0.78;
    }
    .left_console.on .left_console_folding h2 {
      display: inline-block;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      width: 100%;
      height: auto;
      position: absolute;
      top: 50%;
      left:0;
      transform: rotate(-90deg);
      white-space:nowrap;
    }
    
    .text_container_top {
      position: relative;
      display:flex;
      background: #3b3b3f;
      height: 50px;
      text-align: center;
    }
    .text_container_top:after {
      content: "";
      clear: both;
      display: block;
    }
    .text_container_top h2 {
      float: left;
      width: calc(100% - 50px);
      margin: 0px;
      font-size: 15px;
      color: #fff;
      line-height: 50px;
      font-weight: 500;
    }
    #firstB {
      position: relative;
      float: left;
      width: 50px;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      background: #3b3b3f;
      border: 0;
      outline: none;
      padding: 0;
      appearance: none;
    }
    #firstB img,
    #prevB img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 11px;
      height: 11px;
      opacity: 0.78;
    }
    #prevB {
      position: absolute;
      top: 0;
      left: 50px;
      width: 50px;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      background: #3b3b3f;
      border: 0;
      outline: none;
      padding: 0;
      appearance: none;
    }
    .text_container_content{
      position:relative;
      height: calc(100% - 50px);
      background:#2e2e32;
    }
    .text_container_content:after {
      content: "";
      clear: both;
      display: block;
    }
    .control_fix_div{
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 14px;
      border-top: 1px solid #1f1f24;
      width: 100%;
      text-align: right;
    }
    .control_fix_div input{display:none;}
    .control_fix_div label{
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .control_fix_div input + label span{
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      box-sizing: border-box;
      background: url(${ChkIcon}) no-repeat;
      background-size:cover;
    }
    .control_fix_div input:checked + label span{
      background: url(${ChkOnIcon}) no-repeat;
      background-size:cover;
    }
    .control_list li {border-bottom:0 !important;}
    .control_list li img{opacity:0.3;}
    .control_list li.on img{opacity:1;}
    .control_list li.on a {
      background: #000;
    }

    
    .control_list li.on a img {
      opacity: 1;
    }
    
    .control_list a {
      display: flex;
      align-items: center;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff !important;
      background: #2e2e32;
      padding: 15px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .control_list a span {
      font-size: 13px;
      font-weight: 400;
      display: inline-block;
      margin-left: 15px;
    }
    .control_list a.selected {
      background: #27272b;
    }
    .control_list a.selected img {
      opacity: 1;
    }
    .control_list.on {
      float: left;
      width: 50px;
    }
    .control_list.on span {
      display: none;
    }
    .control_list.on .control_list li:last-child {
      border-bottom: 0;
    }
    
    .control_content {
      position: relative;
      float: left;
      width: calc(100% - 50px);
      background: #000;
      height: 100%;
      padding:8px;
    }
    .control_content.none {
      display: none;
    }
    .control_content .top_title{margin-bottom:6px;}
    .control_content .top_title span {
      font-size: 12px;
      padding: 0px 0px 0px 8px;
      display: block;
      color: #5e5e61;
      font-weight:400;
    }

    .control_content_list{margin-bottom:8px;}
    .control_content_list li{
      border-radius: 6px;
      padding: 10px 8px;
      background:#1c1c1d;
      margin-bottom:6px;
    }
    .control_content_list li:last-child{
      margin-bottom:0;
    }
    .control_content_list a{display: flex;
    justify-content: space-between;
    align-items: center; margin-bottom:8px; cursor:pointer;}
    .control_content_list a span {
      font-size: 12px;
      color: #fff;
      line-height: 1.43;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
      overflow:hidden;
    }
    .control_content_list .control_content_list_tool{display:flex; justify-content:flex-end; align-items:center;}
    .control_content_list .control_content_list_tool > div {display:flex; align-items:center;}
    .control_content_list .control_content_list_tool > div span{
      display:block;
      font-size: 11px;
      font-weight: 400;
      line-height: 11px;
      color: #646464;
      margin-right:4px;
    }
    .control_content_list .control_content_list_tool > div span img{
      position: absolute;
      top: 50%;
      left: 6px;
      transform: translateY(-50%);
    }
    .control_content_list .control_content_list_tool label.switch{margin-right:4px;}
    /* 토글 체크박스 */
    label.switch {
        position: relative;
        width: 30px;
        height: 16px;
        border-radius: 20px;
        background: #202026;
        cursor: pointer;
    }
    label.switch input[type='checkbox'] {
        display:none;}
    label.switch span {
        position: relative;
        width: 100%;
        height: 100%;
        display: inline-block;
    }
    label.switch span::before {
        content: '';
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #999999;
        border-radius: 14px; }
        label.switch span::after {
        content: '';
        position: absolute;
        display: block;
        width: 8px;
        height: 8px;
        background-color: #fff;
        border-radius: 50%;
        top: 50%;
        left: 5px;
        transform:translateY(-50%);
        transition: left .3s ease;
        box-shadow: 0 2px 4px 0 rgb(90 90 90 / 50%);
    }
    label.switch input:checked ~ span::before {
        border: 1px solid #7758fa;
        background-color: #7758fa; }
    label.switch input:checked ~ span::after {
        left: 17px; }
    .control_content_list .control_content_list_tool .on_off_exporsure{cursor:auto;}
    .control_content_list .control_content_list_tool .on_off_exporsure strong{
      display: block;
      width:30px;
      padding:1px 0;
      font-size: 8px;
      font-weight: bold;
      text-align: left;
      color: #7758fa;
      border-radius: 14px;
      border: solid 1px #7758fa;
      text-align:center;
    }
    .control_content_list .control_content_list_tool .on_off_exporsure strong.off{
      color: #5e5e61;
      border: solid 1px #5e5e61;
    }



    .control_content_detail {
      position: relative;
      float: left;
      width: calc(100% - 50px);
      background: #000;
      height: 100%;
      padding:10px;
      z-index: 999;
    }
    .control_content_detail > div{
      border-radius: 8px;
      background-color: #1c1c1d;
      margin-bottom:8px;
    }
    .control_content_detail > div:first-child{padding:8px;}
    .control_content_detail > div h4{
      font-size: 12px;
      line-height: 1.5;
      color: #fff;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
      overflow:hidden;
    }
    .control_content_detail > div li {
      display:flex;
      align-items:center;
      justify-content:space-between;
      padding:8px;
      border-bottom: 1px solid #000;
    }
    .control_content_detail > div li .survey_exposure_inner{
      height:16px;
    }
    .control_content_detail > div li:last-child {
      border-bottom: 0;
      cursor:pointer;
    }
    .control_content_detail > div li div a{
      display: flex;
      align-items:center;
      justify-content:center;
      width: 18px;
      height: 18px;
      text-align: center;
    }
    .control_content_detail > div li div span{
      font-size: 11px;
      font-weight: 400;
      line-height: 14px;
      display:block;
      color: #fff;
    }
    .control_content_detail > div li h5{
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #646464;
      line-height: 18px;
    }
    
    .control_content_detail .connect_way_div_inner{
      display:flex;
      justify-content:flex-end;
      align-items:center;
    }
    .control_content_detail .connect_way_div input {
      display: none;
    }
    .control_content_detail .connect_way_div input[type="radio"] + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 5px;
      box-sizing: border-box;
      background: url("https://cdn.onoffevent.com/common/form_radio_off.svg");
      cursor:pointer;
    }
    .control_content_detail .connect_way_div input[type="radio"]:checked + label span {
      background: url("https://cdn.onoffevent.com/common/form_radio_on.svg");
      cursor:pointer;
    }
    .control_content_detail .connect_way_div label {
      display: flex;
      align-items: center;
      font-size: 11px;
      color: #fff;
      margin-right: 10px;
    }
    .control_content_detail .connect_way_div label:last-child {
      margin-right: 0;
    }
    .control_content_detail .progress_complete input {
      display: none;
    }
    .control_content_detail .progress_complete input + label {
      display: flex;
      align-items: center;
      font-size: 11px;
      font-weight:500;
      color:#fff;
      cursor:pointer;
    }
    .control_content_detail .progress_complete input + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border-radius: 4px;
      box-sizing: border-box;
      background: url("${ChkIcon}") no-repeat;
      background-size:cover;
      cursor:pointer;
    }
    .control_content_detail .progress_complete input:checked + label span {
      background: url("${ChkOnIcon}") no-repeat;
      background-size:cover;
      cursor:pointer;
    }

    .control_content_detail > div li.survey_edit h5{
      font-size: 12px;
      font-weight: 500;
      color: #7758fa;
      line-height:18px;
    }
    .control_content_detail > div li.console_edit h5{
      font-size: 12px;
      font-weight: 400;
      color: #646464;
      line-height:18px;
    }

    .streaming_content_list li.selected {
      border: 1px solid #7758fa;
    }
    .streaming_content_list li.streaming_empty_item {
      text-align: center;
      padding: 16px 8px;
      color: #8b8b90;
      font-size: 12px;
    }
    .streaming_content_list li.streaming_empty_item span {
      margin: 0;
      color: #8b8b90;
    }
    .streaming_status_badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 56px;
      height: 20px;
      padding: 0 8px;
      border-radius: 999px;
      font-size: 10px;
      font-weight: 600;
      line-height: 1;
      color: #d1d5db;
      background: #3b3b40;
      margin-left: 8px;
      white-space: nowrap;
    }
    .streaming_status_badge.status_ready {
      color: #22c55e;
      border: 1px solid #22c55e;
      background: rgba(34, 197, 94, 0.15);
    }
    .streaming_status_badge.status_reserved {
      color: #60a5fa;
      border: 1px solid #60a5fa;
      background: rgba(96, 165, 250, 0.15);
    }
    .streaming_status_badge.status_live {
      color: #f87171;
      border: 1px solid #f87171;
      background: rgba(248, 113, 113, 0.15);
    }
    .streaming_status_badge.status_suspended {
      color: #f59e0b;
      border: 1px solid #f59e0b;
      background: rgba(245, 158, 11, 0.15);
    }
    .streaming_status_badge.status_ended {
      color: #a1a1aa;
      border: 1px solid #a1a1aa;
      background: rgba(161, 161, 170, 0.15);
    }
    .streaming_help_box {
      border: 1px solid #1f1f24;
      background: #1a1a1d;
      border-radius: 8px;
      padding: 10px;
    }
    .streaming_help_box p {
      font-size: 11px;
      color: #8b8b90;
      line-height: 1.4;
      margin: 0 0 8px 0;
    }
    .streaming_help_box button {
      width: 100%;
      height: 30px;
      border-radius: 6px;
      border: 0;
      background: #5959ef;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
    }
    .streaming_selected_title p {
      margin-top: 6px;
      font-size: 11px;
      color: #8b8b90;
    }
    .streaming_empty_state {
      padding: 16px;
      font-size: 12px;
      color: #8b8b90;
      text-align: center;
    }
    .streaming_modal_dim {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.62);
      z-index: 1100;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      box-sizing: border-box;
    }
    .streaming_modal {
      width: 460px;
      max-width: 100%;
      max-height: 85vh;
      border-radius: 10px;
      overflow: hidden;
      background: #202026;
      border: 1px solid #34343a;
      box-shadow: 0 24px 40px rgba(0, 0, 0, 0.42);
    }
    .streaming_modal.streaming_modal_wide {
      width: 760px;
    }
    .streaming_modal_head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 16px;
      border-bottom: 1px solid #33333a;
    }
    .streaming_modal_head h3 {
      font-size: 14px;
      color: #fff;
      margin: 0;
      font-weight: 500;
    }
    .streaming_modal_head button {
      border: 0;
      background: transparent;
      color: #c5c7cf;
      font-size: 12px;
      cursor: pointer;
      padding: 0;
    }
    .streaming_modal_body {
      padding: 14px 16px;
      max-height: calc(85vh - 53px);
      overflow-y: auto;
    }
    .streaming_modal_body ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .streaming_modal_body ul li {
      border-bottom: 1px solid #2f2f35;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }
    .streaming_modal_body ul li:last-child {
      border-bottom: 0;
    }
    .streaming_modal_body ul li strong {
      font-size: 12px;
      color: #a0a0aa;
      flex-shrink: 0;
    }
    .streaming_modal_body ul li span {
      font-size: 12px;
      color: #fff;
      text-align: right;
      word-break: break-all;
    }
    .streaming_channel_table {
      width: 100%;
      border-collapse: collapse;
    }
    .streaming_channel_table th,
    .streaming_channel_table td {
      border-bottom: 1px solid #2f2f35;
      padding: 8px 6px;
      font-size: 11px;
      text-align: left;
      color: #fff;
      vertical-align: middle;
    }
    .streaming_channel_table th {
      color: #8b8b90;
      font-weight: 500;
    }
    /*===========right_console=============*/
    .admin_console_top {
      display: flex;
      justify-content: left;
      align-items: center;
      background: #3b3b3f;
      height: 50px;
      position: relative;
    }
    .admin_console_top h2 {
      font-size: 15px;
      color: #fff;
      margin: 0 auto;
    }
    .admin_console_top button {
      width: 50px;
      height: 50px;
    }
    .right_console button {
      position:absolute;
      top: 0;
      right: 0;
      width: 50px;
      height: 50px;
      transform: rotate(180deg);
      transition: all 0.3s;
    }
    .right_console button img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
    .right_console.on button {
      transform: rotate(0deg);
      width: 30px;
      height: 50px;
    }
    .right_console_content {
      padding: 0px 16px;
      background:#2E2E32;
      height: calc(100% - 50px);
    }
    .right_console_content p {
      font-size: 14px;
      color: #fff;
      font-weight: normal;
      padding: 8px 0;
    }
    .right_console_content span {
      display:flex;
      align-items:center;
      justify-content:space-between;
      font-size: 16px;
      font-weight: 800;
      color: #fff;
      line-height: 22px;
      cursor: pointer;
      background: #111;
      padding: 8px;
      border-radius: 4px;
    }
    .right_console .right_console_folding {
      display: none;
    }
    .right_console.on {
      width: 30px;
      height: 220px;
      padding: 0;
      background: rgba(59, 59, 63, 0.5);
    }
    .right_console.on .right_console_folding {
      display: block;
      inline-size: inherit;
      box-sizing: border-box;
    }
    .right_console .right_console_folding button {
      position: relative;
      height: 220px;
      z-index: 999999;
    }
    .right_console .right_console_folding button .arrow_div{
      position: absolute;
      top: 0;
      left: 50%;
      width: 30px;
      height: 30px;
      transform: translateX(-50%);
      background: rgba(26, 26, 26, 0.4);
    }
    .right_console .right_console_folding button .number_div{
      position:relative;
      height: calc(100% - 30px);
      margin-top: 30px;
    }
    .right_console .right_console_folding button img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform:translate(-50%,-50%);
    }
    .right_console.on .right_console_folding h2 {
      font-size: 14px;
      font-weight: 400;
      display: inline-block;
      color: rgb(255,255,255);
      position: absolute;
      bottom: 70px;
      left: -35%;
      width: auto;
      -webkit-transform: rotate(-90deg);
      -ms-transform: rotate(-90deg);
      transform: rotate(-90deg);
      white-space: nowrap;
      text-align: center;
    }
    .right_console.on .right_console_folding span {
      font-size: 14px;
      display: inline-block;
      font-weight: 700;
      text-align: left;
      color: #fff;
      transform: rotate(-90deg) translateY(-50%);
      width: 20px;
      position: absolute;
      top: 40px;
      text-align: center;
      left: 50%;
    }
    .right_console.on .admin_console_top,
    .right_console.on .right_console_content {
      display: none;
    }
    .right_console.on .admin_console_top h2 {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%) rotate(180deg);
      writing-mode: vertical-lr;
    }
`

export default commonStyle;
